import axios, { AxiosResponse } from 'axios';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import React, { FC, useContext, useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { Button , Dimmer, Loader} from 'semantic-ui-react';
import { AdminContext } from "../../contexts/AdminContext";
import { config } from "../../contexts/UrlContext";
import LocationMultiSearch from "../ContentManager/LocationMultiSearch";
import AuthContext from '../../contexts/AuthContext';
import { getRequest, postRequest } from '../../services/axiosService';


const General:FC = () => {

    const { auth } = useContext(AuthContext);


    const [dbId, setDbId] = useState<string>("");
    const [workGroupServer, setWorkgroupServer] = useState<string>("");
    const [workGroupServerURL, setWorkgroupServerURL] = useState<string>("");
    const [tempPath, setTempPath] = useState<string>("");
    const [adminWhiteList, setAdminWhiteList] = useState<any>(null);
    const [adminWhiteListURI, setAdminWhiteListURI] = useState<any[]>([]);
    const [adminWhiteListAvailable, setAdminWhiteListAvailable] = useState<any[]>([]);

    const [basicWhiteList, setBasicWhiteList] = useState<any>(null);
    const [basicWhiteListURI, setBasicWhiteListURI] = useState<any[]>([]);
    const [basicWhiteListAvailable, setBasicWhiteListAvailable] = useState<any[]>([]);

    const [statsWhiteList, setStatsWhiteList] = useState<any>(null);
    const [statsWhiteListURI, setStatsWhiteListURI] = useState<any[]>([]);
    const [statsWhiteListAvailable, setStatsWhiteListAvailable] = useState<any[]>([]);

    const [loading, setLoading] = useState<boolean>(false);

    const { generalSettings, setGeneralSettings } = useContext(AdminContext);

    useEffect(() => {
        getAdminSettings();
    }, [])

    const saveSettings = async () => {
        try {
            if (dbId === null || dbId === "") {
                toast.error("Database Id cannot be empty");
                return;
            }

            if ((workGroupServer === null || workGroupServer === "") && (workGroupServerURL === null || workGroupServerURL === "")) {
                toast.error("Either a Workgroup server URL or name must be provided");
                return;
            }

            if (tempPath === null || tempPath === "") {
                toast.error("Temp Path cannot be empty");
                return;
            }

            let newSettings = {
                databaseID: dbId,
                workgroupServerName: workGroupServer,
                workgroupServerURL: workGroupServerURL,
                tempPath: tempPath,
                adminWhiteList: adminWhiteListURI,
                basicWhiteList: basicWhiteListURI,
                statisticsWhiteList: statsWhiteListURI,
            };

            let response: AxiosResponse = await postRequest(auth, `/Admin/SaveGeneralSettings`, newSettings);

            toast.success("Settings saved");
            setGeneralSettings(newSettings);
        } catch (error) {
            console.log(error);
            toast.error("Unable to save settings");
        }
    }

    const getAdminSettings = async () => {
        setDbId(generalSettings.databaseID);
        setWorkgroupServer(generalSettings.workgroupServerName);
        setWorkgroupServerURL(generalSettings.workgroupServerURL);
        setTempPath(generalSettings.tempPath);
        setAdminWhiteListURI(generalSettings.adminWhiteList);
        setBasicWhiteListURI(generalSettings.basicWhiteList);
        setStatsWhiteListURI(generalSettings.statisticsWhiteList);
        if (generalSettings.adminWhiteList !== null && generalSettings.adminWhiteList.length > 0) {
            await getAdminWhiteList();
        }
        if (generalSettings.basicWhiteList !== null && generalSettings.basicWhiteList.length > 0) {
            await getBasicWhiteList();
        }
        if (generalSettings.statisticsWhiteList !== null && generalSettings.statisticsWhiteList.length > 0) {
            await getStatsWhiteList();
        }
    }

    const getAdminWhiteList = async () => {

        try {
            let response: AxiosResponse = await getRequest(auth, `/Search/GetAdminWhiteListLocations`);

            let adminWhiteList: any = [];
            let adminWhiteListAvailable: any = [];

            response.data.map((location: any) => {
                adminWhiteList.push(location.name)

                adminWhiteListAvailable.push({
                    key: location.value,
                    text: location.name,
                    value: location.value
                })
            });

            setAdminWhiteList(adminWhiteList);
            setAdminWhiteListAvailable(adminWhiteListAvailable);
        } catch (error) {
            console.log(error);
            toast.error(`Unable to get Admin White List Locations`);
        }
    }

    const getBasicWhiteList = async () => {

        try {
            let response: AxiosResponse = await getRequest(auth, `/Search/GetBasicWhiteListLocations`);

            let basicWhiteList: any = [];
            let basicWhiteListAvailable: any = [];

            response.data.map((location: any) => {
                basicWhiteList.push(location.name)

                basicWhiteListAvailable.push({
                    key: location.value,
                    text: location.name,
                    value: location.value
                })
            });

            setBasicWhiteList(basicWhiteList);
            setBasicWhiteListAvailable(basicWhiteListAvailable);
        } catch (error) {
            console.log(error);
            toast.error(`Unable to get Basic White List Locations`);
        }
    }

    const getStatsWhiteList = async () => {
        try {
            let response: AxiosResponse = await getRequest(auth, `/Search/GetStatsWhiteListLocations`);
            let statsWhiteList: any = [];
            let statsWhiteListAvailable: any = [];

            response.data.map((location: any) => {
                statsWhiteList.push(location.name)

                statsWhiteListAvailable.push({
                    key: location.value,
                    text: location.name,
                    value: location.value
                })
            });

            setStatsWhiteList(statsWhiteList);
            setStatsWhiteListAvailable(statsWhiteListAvailable);

        } catch (error) {
            console.log(error);
            toast.error(`Unable to get Stats White List Locations`);
        }
    }

    async function downloadLogs () {
        try {
            setLoading(true);
            let response: AxiosResponse = await getRequest(auth, `/Admin/DownloadLogs`);

            let files = response.data;
            let zip = new JSZip();
    
            files.forEach((file: any) => {
                zip.file(file.fileName, file.contentsStr, { binary: true });
            });
    
            zip.generateAsync({ type: "blob" })
                .then(function (content: any) {
                    saveAs(content, "CM2WebShare Logs.zip");
                    setLoading(false);
            });
        } catch (error) {
            console.log(error);
            toast.error(`Unable to download log files`);
            setLoading(false);
        }
    }
    
    const exportSettings = async () => {
        try {
            setLoading(true);
            let response: AxiosResponse = await getRequest(auth, `/Admin/GetSettingsFiles`);

            if (!auth || auth == null) {
                response = await axios.get(`${config.baseUrl}/api/Admin/GetSettingsFiles`);
            } else {
                let header = {
                    Authorization: `Bearer ${auth.user?.access_token}`,
                }
                response = await axios.get(`${config.baseUrl}/api/Admin/GetSettingsFiles`, { headers: header });
            }

            let files = response.data;
            let zip = new JSZip();

            files.forEach((file: any) => {
                let binary_string = window.atob(file.contents);
                let len = binary_string.length;
                let bytes = new Uint8Array(len);
                for (let i = 0; i < len; i++) {
                    bytes[i] = binary_string.charCodeAt(i);
                }

                let byteArr: number[] = Array.from(bytes);
                zip.file(file.fileName, String.fromCharCode.apply(null, byteArr), { binary: true });
            });

            zip.generateAsync({ type: "blob" })
            .then(function (content: any) {
                // see FileSaver.js
                saveAs(content, "CM2WebShare Settings Files.zip");
                setLoading(false);
            });
        } catch (error) {
            console.log(error);
            toast.error(`Unable to download settings files`);
            setLoading(false);
        }
    }

    const importFilesChange = (event: any) => {
        let files = event.target.files;
    
        if (files !== null && files.length > 0) {
            importSettings();
        }
    }
    
    const importSettings = async () => {
        try {
            let formData = new FormData();
            let fileInput: any = document.querySelector('#file');
            let files = fileInput.files;
        
            for (let i = 0; i < files.length; i++) {
                formData.append("files", files[i]);
            }

            let response: AxiosResponse;

            if (!auth || auth == null) {
                response = await  axios.post(`${config.baseUrl}/api/ContentManager/ImportSettings`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            } else {
                let header = {
                    'Authorization': `Bearer ${auth.user?.access_token}`,
                    'Content-Type': 'multipart/form-data'
                }
                response = await  axios.post(`${config.baseUrl}/api/ContentManager/ImportSettings`, formData, {
                    headers: header
                });
            }

            toast.success("Successfully Imported Settings");
            window.location.reload();
        } catch (error) {
            console.log(error);
            toast.error("An error occurred, please check logs");
        }
    }

    if (loading)
    {
        return (
            <div className="ui admin-container" style={{ borderBottom: "0" }} id="general-settings">
                <Dimmer inverted active={true} style={{marginTop:15}}>
                    <Loader inverted>Loading...</Loader>
                </Dimmer>
            </div>
        )
    }

    return (
        <div className="ui admin-container" style={{ borderBottom: "0" }} id="general-settings">
            <div className="header blue headerStyleBlue" >Import/Export Settings</div>
            <div className="buttonStyle">
                <input className="ui button" type="submit" onClick={exportSettings} value="Export Settings" />
                <div className="upload-btn-wrapper" style={{ marginLeft: 5, cursor:"pointer" }}>
                    <button className="ui button" id="importButton" style={{ cursor: "pointer" }}> Import Settings </button>
                    <input type="file" name="myfile" id="file" accept=".json" multiple onChange={importFilesChange} style={{ height: "95%", width: "100%" }} />
                </div>
            </div>

            <div className="header blue headerStyleBlue"> Download Logs</div>
            <div className="buttonStyle">
                <input className="ui button" type="submit" onClick={downloadLogs} value="Download Logs" />
            </div>

            <div className="header blue headerStyleBlue" >Access</div>
            <div className="header gray headerStyleGray">BASIC</div>
            <div className="meta" style={{ marginLeft: '10px' }}>Whitelist the users to have access to CM2WebShare</div>
            <LocationMultiSearch auth={auth} label="Whitelist the users to have access to CM2WebShare" value={basicWhiteListURI} text={basicWhiteList} change={setBasicWhiteListURI} options={basicWhiteListAvailable} />

            <div className="header gray headerStyleGray">ADMIN</div>
            <div className="meta" style={{ marginLeft: '10px' }}>Whitelist the users to have admin access to CM2WebShare</div>
            <LocationMultiSearch auth={auth} label="Whitelist the users to have admin access to CM2WebShare" value={adminWhiteListURI} text={adminWhiteList} change={setAdminWhiteListURI} options={adminWhiteListAvailable}/>

            <div className="header gray headerStyleGray">STATISTIC</div>
            <div className="meta" style={{ marginLeft: '10px' }}>Whitelist the users to have statistic access to CM2WebShare</div>
            <LocationMultiSearch auth={auth} label="Whitelist the users to have statistic access to CM2WebShare" value={statsWhiteListURI} text={statsWhiteList} change={setStatsWhiteListURI} options={statsWhiteListAvailable} />

            <div className="header blue headerStyleBlue">Advanced</div>

            <div className="header gray headerStyleGray">DATASET ID</div>
            <div className="ui input fluid" style={{ marginLeft: '10px' }} >
                <input type="text" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Database ID" id="dbid" value={dbId} onChange={(e) => {setDbId(e.target.value)}} />
            </div>

            <div className="header gray headerStyleGray">WORKGROUP SERVER NAME</div>
            <div className="ui input fluid" style={{ marginLeft: '10px' }} >
                <input type="text" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Workgroup Server Name" id="workgroup" value={workGroupServer} onChange={(e) => {setWorkgroupServer(e.target.value)}} />
            </div>

            <div className="header gray headerStyleGray">WORKGROUP SERVER URL</div>
            <div className="ui input fluid" style={{ marginLeft: '10px' }} >
                <input type="text" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Workgroup Server URL" id="workgroupURL" value={workGroupServerURL} onChange={(e) => { setWorkgroupServerURL(e.target.value) }} />
            </div>

            <div className="header gray headerStyleGray">TEMP PATH</div>
            <div className="ui input fluid" style={{ marginLeft: '10px' }} >
                <input type="text" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Temp Path" id="temppath" value={tempPath} onChange={(e) => {setTempPath(e.target.value)}} />
            </div>

            <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "left", alignContent: "stretch", margin: 10 }}>
                <Button id="general-save" style={{ marginTop: 20 }} onClick={saveSettings}>Save</Button>
                <Button id="general-cancel" style={{ marginTop: 20, marginLeft: 5 }} onClick={getAdminSettings}>Cancel</Button>
            </div>
        </div>
    );
}


export default General;